@if(this.notification.visible){
<div [ngClass]="NotificationType[notification.type]"
     animate.leave="leave-animation"
     [animate.enter]="notification.state === 'showagain' ? 'enter-showagain' : 'enter-new'"
     (animationend)="onAnimationEnd()"
     class="notification infobox warning_infobox"
     [attr.data-maximum-severity]="NotificationType[notification.type]" 
     [attr.role]="firstTime() ? 'alert' : ''"
     aria-live="assertive">
  <div class="notification-header">
    <h2><span class="exclamationIcon" [ngClass]="NotificationType[notification.type]"></span>
    <span class="notificationHeaderText">{{notification.header}}</span></h2>
    <button title="Hinweis schließen" (click)="hideNotification()" class="image infobox_close">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 1000 1000" xml:space="preserve">
        <g>
          <path d="M638.6,500l322.7-322.7c38.3-38.3,38.3-100.3,0-138.6C923,0.4,861,0.4,822.7,38.7L500,361.4L177.3,38.7C139,0.4,77,0.4,38.7,38.7C0.4,77,0.4,139,38.7,177.3L361.4,500L38.7,822.7C0.4,861,0.4,923,38.7,961.3C57.9,980.4,82.9,990,108,990s50.1-9.6,69.3-28.7L500,638.6l322.7,322.7c19.1,19.1,44.2,28.7,69.3,28.7c25.1,0,50.1-9.6,69.3-28.7c38.3-38.3,38.3-100.3,0-138.6L638.6,500z"
            />
        </g>
      </svg>
    </button>
  </div>
  @if (notification.messages.length >= 2) {
    <div class="notification-content">
      <ul class="notification-list">
        <!-- TICKET 330322 :Durch innerhtml wird der Inhalt ungefiltert ausgeben !-->
        @for (msg of notification.messages; track msg) {
          <li class="">{{msg}}</li>
        }
      </ul>
    </div>
  }
  @if (notification.messages.length < 2) {
    <div class="notification-content">
      @for (msg of notification.messages; track msg) {
        <div class="">{{msg}}</div>
      }
    </div>
  }
  <div>
    <button (click)="hideNotification()"
      class="closeButtonMessagesESC"
      title="{{'view.controls.clipboard_close' | hisUi}} {{'messagebox.close.helptext' | hisUi}}">
      <span>{{'view.controls.clipboard_close_esc' | hisUi}}</span>
    </button>
  </div>
</div>


}